export default __webpack_public_path__ + "static/schema_animation-7cc6db0bb5cdc0e72c00470e5aa096ff.mp4";